import { post } from './fetch'

export const sendMessage = (data) => {
  return post('support/feedback-guest', data)
}
